import { FC } from 'react'
import Styles from './ModalTitle.module.scss'
import cx from 'classnames'

interface Props {
  className?: string
}

export const ModalTitle: FC<React.PropsWithChildren<Props>> = ({ children, className }) => {
  return <h2 className={cx(Styles.title, className, Styles.v2)}>{children}</h2>
}
